import { Flex } from '@coolblue-development/freddy';
import { DistinctProperty } from '@features/product/typings';
import { useState } from 'react';

import Cell from '../Cell';
import Text from './Text';

const PropertyValueRow = ({ values }: { values: DistinctProperty[] }) => {
  const [expanded, expand] = useState(false);

  return (
    <Flex component='ul'>
      {values.map((value, index) => (
        <Cell key={`${value.displayName}-${index}`}>
          {typeof value.value === 'string' ? (
            <Text expanded={expanded} expand={expand} text={value.value} />
          ) : (
            value.value
          )}
        </Cell>
      ))}
    </Flex>
  );
};

export default PropertyValueRow;
